import React from "react";
import {
  QueryImports,
  QueryImportSummaries,
  SubscribeImportsUpdate,
} from "../../../utils/graphql/hooks/importsHooks";

export default function ImportsDataManager() {
  QueryImports();
  QueryImportSummaries();
  SubscribeImportsUpdate();
  return <></>;
}
